





















































import { Component, Vue, } from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import * as RouteNames from "@/employee/route-names";
import { FetchState, HsabSsoDestination, LinkedBankAccountUse, LinkedBankAccountUseStatus } from "@/shared/types";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useHsabEnrollmentStore } from "@/employee/store/hsabEnrollment";
import _ from "lodash";

@Component({
  computed: {
    FetchState () {
      return FetchState;
    },
    HsabSsoDestination () {
      return HsabSsoDestination;
    }
  },
  components: { SsoDeepLink, GenericLoadingSpinner }
})
export default class HsabExpensePaymentDetails extends Vue {
  contactInformationStore = useContactInfoStore();
  hsabEnrollmentStore = useHsabEnrollmentStore();
  bankAccountStore = useBankAccountStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  featureFlagStore = useFeatureFlagStore();
  RouteNames = RouteNames;

  mounted () {
    this.contactInformationStore.getContactInformation();
    this.bankAccountStore.loadLinkedBankAccounts();
  }

  get hasDirectDepositAccount () {
    return this.bankAccountStore.hasDirectDeposit;
  }

  get directDepositAccount () {
    if (this.hasDirectDepositAccount) {
      return _.find(this.bankAccountStore.linkedAccounts, x => {
        return x.use !== null
            && x.use.accountUse === LinkedBankAccountUse.DirectDeposit
            && x.use.status === LinkedBankAccountUseStatus.Active;
      });
    }

    return null;
  }

  get directDepsoitAccountNumberLast4 () {
    if (this.hasDirectDepositAccount) {
      return this.directDepositAccount.bankAccountNumber;
    }
    return "";
  }

  get userHasPlanNotSetToDirectDeposit () {
    return this.hsabEnrollmentStore.isPlanYearEnrollmentDataLoaded
        && this.hasDirectDepositAccount
        && this.hsabEnrollmentStore.userHasNonDirectDepositReimbursementMethod;
  }

  get reimbursementMethodDisplayString () {
    if (this.hasDirectDepositAccount === false) {
      return "Check";
    }
    if (this.userHasPlanNotSetToDirectDeposit === false) {
      return "Direct deposit";
    }

    return "";
  }

  get linkedAccountsEnabled (): boolean {
    return this.featureFlagStore.flags.bend23473DisplayLinkedAccountsForHsab;
  }

  onLinkAccountSettingsClicked () {
    this.hsabExpenseFormStore.closeModal();
    this.$router.push({ name: RouteNames.LinkedAccountsSettings });
  }
}
